export enum AudioSpeed {
  VerySlow = 'verySlow',
  Slow = 'slow',
  Regular = 'regular',
  Fast = 'fast',
  VeryFast = 'veryFast',
}

export interface TTSRequest {
  text: string; // text to synthesize
  voice: string; // compatible voice to use
  generateTranscription: boolean; // whether to generate a transcription
  speedRate: number; // speed rate
  speed?: AudioSpeed; // speed
  ssml?: string; // ssml
  path?: string; // Optional path to save the file in cloud storage
}

export interface TTSVoice {
  languageCodes: string[];
  name: string;
  ssmlGender: 'MALE' | 'FEMALE' | 'NEUTRAL';
  naturalSampleRateHertz: number;
}
